import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "2D Turn-based Strategy Game Development",
    description:
      "Develop complex, grid-based tactical games that challenge players with strategic planning and resource management.",
    count: "01",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Horror Game Development",
    description:
      "Craft intense, atmospheric horror experiences with chilling environments, dynamic scares, and immersive storytelling.",
    count: "02",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Platformer Game Development",
    description:
      "Design challenging platformers with precise controls, intricate level design, and rewarding exploration.",
    count: "03",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Puzzle Game Development",
    description:
      "Create mind-bending puzzles that demand creative thinking and logical problem-solving, offering satisfying progression.",
    count: "04",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Side-Scroller Game Development",
    description:
      "Build immersive side-scrolling adventures with detailed environments, engaging combat, and narrative-driven exploration.",
    count: "05",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Metroidvania Game Development",
    description:
      "Develop expansive worlds where exploration, combat, and character progression intertwine, uncovering secrets and abilities.",
    count: "06",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Rogue-lite Game Development",
    description:
      "Design procedurally generated levels with permadeath mechanics, ensuring dynamic gameplay and high replayability.",
    count: "07",
  },
  {
    logo: GenerativeAIServiceTick,
    title: "2D Turn-based Strategy Game Development",
    description:
      "Develop complex, grid-based tactical games that challenge players with strategic planning and resource management.",
    count: "08",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 nlp_process_flow search-engine-workflow">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Our Prowess Across <span>2D Game Genres</span>
            </h2>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Game Designers
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-lg-1 mt-3 mt-md-0"
          >
            <p>
              Engineered to perfection, we specialize in creating advanced 2D
              games with genre-specific mechanics, intricate designs, and
              immersive player experiences.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-3 mb-md-4">
              <div
                className="workflow_items"
                style={{ background: "#F6F6F6", pointerEvents: "none" }}
              >
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
